import './loading.scss'

/* FontAwesome */
import { FontAwesomeIcon as FontAwesome } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

interface Props {
  fullScreen?: boolean
}

const Loading: React.FC<Props> = ({ fullScreen=false }) => (
  <div 
    className={[
      'Component-Loading',
      fullScreen ? 'fullScreen' : null
    ].join(' ')}
    data-testid="Loading"
  >
    <FontAwesome icon={faSpinner} size="4x" spin />
  </div>
)

export default Loading